import { __rest } from "tslib";
/* eslint-disable react/display-name */
import React from 'react';
import { Tooltip as MuiTooltip, tooltipClasses, } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLORS, FONT_WEIGHTS } from '../../theme/constants';
export const Tooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(MuiTooltip, Object.assign({}, props, { arrow: true, classes: { popper: className } }), props.children));
})(() => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: COLORS.DARK_GRAY,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: COLORS.DARK_GRAY,
        color: COLORS.SECONDARY,
        padding: '8px',
        fontWeight: FONT_WEIGHTS.REGULAR,
        fontSize: '12px',
        lineHeight: '16px',
        fontFamily: 'Nunito Sans',
    },
}));
